export function timeConverter(UNIX_timestamp){
  let a = new Date(UNIX_timestamp * 1000);
  let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  let year = a.getFullYear();
  let month = months[a.getMonth()];
  let date = a.getDate();
  let hour = a.getHours();
  let min = a.getMinutes();
  let sec = a.getSeconds();
  let time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min
    // + ':' + sec ;
  return time;
}


export function capitalize(string){
  return string?.toString().charAt(0).toUpperCase().concat(string?.toString().slice(1))
}

export function removeUnderscoreAndCapitalize(string){
  return string?.toString().charAt(0).toUpperCase().concat(string?.toString().slice(1)).replaceAll("_"," ")
}